import { BusinessModelEnum } from '@/entities/user/models/BusinessModel'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Order } from '../models/Order'

type SaveOrderPayload = {
  order: Record<string, unknown>
}

// TODO: Why does OLMS API for saveOrder only return partial information when we save? This can lead to stale data in the UI.
// TODO: Add a way to match orders against scheduleId and shiftId
export const saveOrder = createAsyncThunk<Order | null, SaveOrderPayload, ThunkApiContext>('orders/saveOrder', async ({ order }: SaveOrderPayload, { getState }) => {
  const state = getState()
  const businessModel = state.user.businessModel
  const response = await OLMSApiService.post<Order>('order/saveOrder', order)

  // Process orders prior to upsert
  if (businessModel === BusinessModelEnum.Depot && response) {
    if (response.isPickup) {
      response.location = response.fromLocation
      response.depotId = response.toLocation.id
      response.depot = response.toLocation
      response.serviceTime = response.serviceTimePickup
    } else {
      response.location = response.toLocation
      response.depot = response.fromLocation
      response.depotId = response.fromLocation.id
      response.serviceTime = response.serviceTimeDelivery
    }
  }

  return response
})